<template lang="html">
  <div class="custom-manual-wrapper">
    <div class="header">
      {{ $t("main.mainSection") }}
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="proName"
          :label="$t('profile.purchase.subject') + '*'"
          @input="emitChange('pro_name', $event)"
          type="text"
          max-length="40"
        />
      </span>
      <questionmark :id="32" :tooltip="true" />
    </div>

    <div class="info">
      <span class="info-key " style=" display: flex; align-items: center;">
        <datetime
          :placeholder="$t('profile.purchase.expiry') + '*'"
          v-model="date"
          :max-datetime="sixMonthsDate"
          :min-datetime="tomorrowDate"
          type="datetime"
        />
        <questionmark :id="34" :tooltip="true" />
      </span>
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="quantity"
          :label="$t('profile.purchase.quantity') + '*'"
          onkeydown="if(event.key==='.'){event.preventDefault();}"
          @keydown="keyUpQuantity"
          @blur="checkQuantity"
          :disabled="prices.length > 0"
          type="number"
          :step="1"
          max="99999999"
          :min="1"
        />
      </span>
      <questionmark :id="33" :tooltip="true" />
    </div>

    <div class="info">
      <span class="info-key">
        <dropdown
          :defaultText="$t('profile.purchase.mun_unit') + '*'"
          :selected="measurementUnit.value"
          :list="measurementUnit.dropdownList"
          @changeOption="measurementUnit.value = $event"
        />
      </span>
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          type="currency-input"
          :label="$t('profile.purchase.startingPrice') + '*'"
          locale="de"
          :currency="null"
          :disabled="prices.length > 0"
          :value="basePrice"
          :precision="0"
          @change="setBasePrice"
          max-length="9"
        />

        <!-- <currency-input
          :label="$t('profile.purchase.quantity') + '*'"
          locale="de"
          :currency="null"
          :disabled="prices.length > 0"
          :value="basePrice"
          :precision="0"
          @change="
            (basePrice = parseNumber($event)),
              emitChange('pro_base_price', $event)
          "
          maxlength="9"
        /> -->
        <!-- <input :disabled="prices.length > 0" onkeydown="if(event.key==='.'){event.preventDefault();}" @change="basePrice = parseNumber($event.target.value), emitChange('pro_base_price', $event.target.value)" type="number" :step="1" :min="2"> -->
      </span>
      <questionmark :id="31" :tooltip="true" />
    </div>

    <div class="info">
      <span class="info-key">
        <dropdown
          :defaultText="$t('profile.purchase.currency') + '*'"
          :selected="currency.value"
          :list="currency.dropdownList"
          @changeOption="currency.value = $event"
        />
      </span>
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="pro_selling_price"
          :label="$t('profile.purchase.pro_selling_price')"
          :disabled="prices.length > 0"
          max-length="1100"
          type="text"
          @input="emitChange('pro_selling_price', $event)"
        />
      </span>
      <questionmark :id="8" :tooltip="true" />
    </div>

    <div class="info">
      <span class="info-key">
        <dropdown
          :defaultText="$t('profile.purchase.category') + '*'"
          :selected="category.value"
          :list="category.dropdownList"
          @changeOption="selectCategories($event)"
        />
      </span>
      <questionmark :id="51" :tooltip="true" />
    </div>

    <div v-if="subCategoryControll" class="info">
      <span class="info-key">
        <dropdown
          :defaultText="$t('profile.purchase.subcategory')"
          :selected="subcategory.value"
          :list="subcategory.dropdownList"
          @changeOption="selectChildCategories($event)"
        />
      </span>
    </div>

    <div class="info">
      <span class="info-key">
        <!-- <dropdown
          :defaultText="$t('profile.purchase.region')"
          :selected="region.value"
          :list="region.dropdownList"
          @changeOption="region.value = $event"
        /> -->
        <v-select
          :placeholder="$t('profile.purchase.region')"
          v-model="region.value"
          multiple
          :options="region.dropdownList"
        >
          <template #open-indicator="{ attributes }">
            <!-- <span v-bind="attributes">🔽</span> -->
            <img
              v-bind="attributes"
              src="@/assets/icons/dropdownArrowBig.png"
              alt="dropdown arrow icon"
            />
          </template>
          <template #no-options="{ search, searching, loading }">
            <span></span>
          </template>
        </v-select>
      </span>
      <questionmark :id="52" :tooltip="true" />
    </div>

    <div
      v-if="
        category.value &&
          Object.keys(filters).length !== 0 &&
          filters.constructor === Object
      "
      class="info"
    >
      <span class="info-key" style="width:120px"
        >{{ $t("profile.purchase.filters") }} :</span
      >
      <span class="info-value">
        <div
          v-for="(value, name) in filters"
          :key="name"
          class="filter-wrapper"
        >
          <dropdown
            style="width:150px; min-width:150px"
            :defaultText="name"
            :selected="getFilterValue(name)"
            :list="value"
            @changeOption="changeFilter(name, $event)"
          />
        </div>
      </span>
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="pro_info"
          :label="$t('profile.purchase.pro_info') + '*'"
          max-length="1100"
          type="textarea"
          @input="emitChange('pro_info', $event.trim())"
          rows="5"
        />
        <!-- :disabled="prices.length > 0" -->
      </span>
      <questionmark :id="6" :tooltip="true" />
      <!-- <span class="info-value">
        <textarea
          maxlength="1100"
          type="text"
          @change="emitChange('pro_info', $event.target.value.trim())"
          rows="5"
        />
      </span> -->
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="pro_description"
          :label="$t('profile.purchase.pro_description') + '*'"
          max-length="1100"
          type="textarea"
          @input="emitChange('pro_description', $event.trim())"
          rows="5"
        />
        <!-- :disabled="prices.length > 0" -->
      </span>
      <questionmark :id="7" :tooltip="true" />
      <!-- <span class="info-value">
        <textarea
          maxlength="1100"
          type="text"
          @change="emitChange('pro_description', $event.target.value.trim())"
          rows="5"
        />
      </span> -->
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="pro_made_in"
          :label="$t('profile.purchase.made') + '*'"
          max-length="1100"
          type="text"
          @input="emitChange('pro_made_in', $event)"
        />
      </span>
      <!-- :disabled="prices.length > 0" -->
      <questionmark :id="41" :tooltip="true" />
    </div>

    <div class="info">
      <span class="info-key">
        <TestInput
          v-model="pro_declaration_text"
          :label="$t('profile.purchase.pro_declaration')"
          max-length="1100"
          type="textarea"
          @input="emitChange('pro_declaration_text', $event)"
        />
        <!-- :disabled="prices.length > 0" -->
        <span style="margin-top: 0px;">{{ $t("main.or") }}</span>
        <div style="flex-direction: column; display: flex;">
          <!-- <div
            class="declaration-wrapper"
            v-for="(declaration, index) in declarations"
            :key="index"
          >
            {{ declaration.name }}
            <img
              style="cursor: pointer;"
              v-if="declarations.length > 0"
              @click="declarations.splice([index], 1)"
              src="@/assets/icons/trash.png"
              alt="trash icon"
            />
          </div> -->
          <!-- <label for="pro_declaration" class="btn">{{
            $t("profile.purchase.choose")
          }}</label>
          <input
            style="display: none;"
            ref="pro_declaration"
            accept=".txt, .docx, .doc, .odt, .jpg, .jpeg, .png"
            id="pro_declaration"
            type="file"
            @change="declarations.push($event.target.files[0])"
          /> -->
          <FileInput @change="declarations.push($event[0])" />
          <div style="display: flex;flex-wrap: wrap; width:100%; gap: 15px;">
            <FileDisplay
              v-for="(declaration, index) in declarations"
              :key="index"
              :fileName="declaration.name"
              @remove-file="declarations.splice([index], 1)"
            />
          </div>
        </div>
      </span>
      <div
        class="info-value"
        style="flex-direction: column; align-items: flex-start;"
      >
        <questionmark :id="42" :tooltip="true" />
        <!-- <input
          maxlength="1100"
          style="margin-top: 0px;"
          type="text"
          @change="emitChange('pro_declaration_text', $event.target.value)"
        /> -->
      </div>
    </div>

    <div class="header">
      {{ $t("main.discountSection") }}
    </div>
    <div
      v-if="!basePrice || !quantity"
      class="info back"
      style="margin-top:0px;"
    >
      <span class="info-key warn-info"
        >*{{ $t("newAd.error.enterDiscount") }}</span
      >
    </div>
    <!-- price discount -->
    <div
      v-if="prices.length < 5 && parseInt(quantityMin) < quantity"
      class="info"
    >
      <span class="info-key" style="width:100%; padding-bottom: 20px ;"
        >{{ $t("profile.purchase.adddiscount") }}* :
        <questionmark :id="19" :tooltip="true" />
      </span>
      <span class="info-value prices">
        <span>{{ $t("profile.purchase.of") }}:</span>
        <span>{{
          quantityMin
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}</span>
        <span>{{ $t("profile.purchase.to") }}:</span>
        <input
          type="number"
          :min="parseInt(quantityMin) + 1"
          v-model="quantityMax"
          :max="quantity"
          @change="
            fixNumber($event.target.min, $event.target.max, 'quantityMax')
          "
          @keydown="rangefunction($event)"
        />
        <span>{{ $t("profile.purchase.price") }}:</span>
        <input
          v-if="prices.length > 0"
          class="input-price"
          type="number"
          :min="1"
          v-model="price"
          @change="fixNumber($event.target.min, $event.target.max, 'price')"
          :max="getMaxPrice"
          :step="1"
        />
        <span v-else>
          {{ basePrice }}
        </span>
        <div @click="addDiscount" class="btn dark">
          <img src="@/assets/newImges/icons/addWhite.svg" alt="" srcset="" />
        </div>
      </span>
    </div>

    <div class="info">
      <span class="info-key" style="width:200px">
        {{ $t("profile.purchase.discounts") }} :
        <questionmark :id="43" :tooltip="true" />
      </span>
      <span
        v-for="(price, index) in prices"
        :key="price.id"
        class="info-value price"
      >
        {{
          price.min
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}
        -
        {{
          price.max
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}: &nbsp;{{
          price.price
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}{{ currency.value ? " " : ""
        }}{{ currency.value ? currency.value.value : "" }}
        <!-- {{ prices[index + 1] ? "" : "" }}&nbsp;&nbsp; -->
      </span>
      <img
        style="cursor: pointer;"
        v-if="prices.length > 0"
        @click="removeDiscount"
        src="@/assets/icons/trash.png"
        alt="trash icon"
      />
    </div>
    <div class="info back ">
      <span class="info-key">*{{ $t("profile.purchase.minDiscount") }}</span>
    </div>
    <div class="line"></div>
    <!-- end price discount -->
    <div
      v-if="socials && socials.length > 0"
      class="header"
      style="margin-bottom: 20px;"
    >
      {{ $t("main.socialsSection") }}
      <questionmark :id="1" :tooltip="true" />
    </div>

    <div v-for="social in socials" :key="social.sct_id" class="info">
      <span class="info-key">
        <TestInput
          v-model="social.value"
          :label="social.sct_name"
          max-length="1100"
          type="text"
          @input="setSocial(social.sct_id, $event)"
        />
      </span>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import Dropdown from "@/components/dropdown.vue";
import Questionmark from "@/components/questionmark.vue";
import TestInput from "../shared/testInput.vue";
import FileInput from "@/components/shared/FileInput.vue";
import FileDisplay from "@/components/shared/FileDisplay.vue";

export default {
  name: "basicInfo",
  components: {
    Dropdown,
    Questionmark,
    TestInput,
    FileInput,
    FileDisplay
  },
  props: {
    params: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      proName: "",
      pro_selling_price: "",
      pro_info: "",
      pro_description: "",
      pro_made_in: "",
      pro_declaration_text: "",
      basePrice: 0,
      quantity: null,
      priceId: 0,
      quantityMin: 1,
      quantityMax: null,
      price: 0,
      prices: [],
      declarations: [],
      nowDate: new Date().toISOString().slice(0, 10),
      date: null,
      category: {
        label: "Category",
        value: null,
        dropdownList: []
      },
      subcategory: {
        label: "Subcategory",
        value: null,
        dropdownList: []
      },
      region: {
        label: "Region",
        value: null,
        dropdownList: []
      },
      measurementUnit: {
        label: "Measurement Unit",
        value: null,
        dropdownList: []
      },
      currency: {
        label: "Currency",
        value: null,
        dropdownList: []
      },
      filters: {},
      selectedFilters: {},
      socials: [],
      socialsSelected: [],
      subCategoryControll: false
    };
  },
  mounted() {
    this.getCategories();
    this.getRegions();
    this.getMeasurementUnits();
    this.getCurrencies();
    this.getSocialTypes();
  },
  computed: {
    tomorrowDate() {
      let today = new Date();
      let tomorrow = new Date(today.setDate(today.getDate() + 1));
      return tomorrow.toISOString();
    },
    sixMonthsDate() {
      let today = new Date();
      let endDate = new Date(today.setMonth(today.getMonth() + 6));
      endDate.setDate(endDate.getDate() - 2);
      return endDate.toISOString();
    },
    getMaxPrice() {
      if (this.prices.length > 0) {
        return this.parseNumber(this.prices[this.prices.length - 1].price) - 1;
      } else {
        return this.parseNumber(this.basePrice);
      }
    },
    calculateMin() {
      let res = 1;
      if (this.prices.length > 0) {
        res = this.prices[this.prices.length - 1].max + 1;
      }
      return res;
    },
    getFilterValue() {
      return name => {
        let obj = null;
        if (this.selectedFilters.hasOwnProperty(name)) {
          obj = this.selectedFilters[name];
        }
        return obj;
      };
    }
  },
  methods: {
    keyUpQuantity(e) {
      if (e.key == "Backspace") {
        console.log(e.key);
      } else if (
        (this.quantity && this.quantity.length > 7) ||
        this.quantity >= 99999999
      ) {
        e.preventDefault();
      }
    },
    setBasePrice(e) {
      this.basePrice = this.parseNumber(e);
      this.emitChange("pro_base_price", e);
    },
    checkQuantity() {
      if (parseInt(this.quantity) < 4) {
        this.quantity = 4;
      }
    },
    removeDiscount() {
      this.prices.pop();
      if (this.prices[this.prices.length - 1]) {
        this.quantityMin =
          parseInt(this.prices[this.prices.length - 1].max) + 1;
        this.quantityMax =
          parseInt(this.prices[this.prices.length - 1].max) + 2;
      } else {
        this.quantityMin = 1;
        this.quantityMax = 2;
      }
    },
    addDiscount() {
      console.log(this.quantityMin, this.quantityMax, this.price);
      if (this.prices.length === 0) {
        this.price = this.basePrice;
      }
      let quantityMin = parseInt(this.quantityMin);
      let quantityMax = parseInt(this.quantityMax);
      let price = this.parseNumber(this.price);
      if (!quantityMin || quantityMin < 1) {
        console.log("quantityMin los");
        return;
      }
      if (!quantityMax || quantityMax <= quantityMin) {
        console.log("quantityMax los");
        return;
      }
      if (quantityMax > this.quantity) {
        this.$toast.error(this.$t("main.quantityMaxError"), {
          duration: 8000
        });
        return;
      }
      if (!price) {
        console.log("price los");
        return;
      }
      let obj = {
        min: quantityMin,
        max: quantityMax,
        price: price
      };
      this.prices.push(obj);
      this.quantityMin = parseInt(this.quantityMax) + 1;
      this.quantityMax = parseInt(this.quantityMax) + 2;
      this.price = null;
    },
    getSocialTypes() {
      api.getSocialTypes().then(res => {
        if (res.data && res.data.data)
          this.socials = res.data.data.map(obj => ({
            ...obj,
            value: ""
          }));
      });
    },
    setSocial(id, link) {
      for (var i = 0; i < this.socialsSelected.length; i++) {
        if (this.socialsSelected[i].sct_id === id) {
          if (link !== "") {
            this.socialsSelected[i].link = link;
          } else {
            this.socialsSelected.splice(i, 1);
          }
          this.emitChange("socials", this.socialsSelected);
          return;
        }
      }
      let obj = {
        sct_id: id,
        link: link
      };
      this.socialsSelected.push(obj);
      this.emitChange("socials", this.socialsSelected);
    },
    emitChange(key, value) {
      let data = {
        key: key,
        value: value
      };
      eventBus.$emit("changeNewAdParams", data);
    },
    getCurrencies() {
      api
        .getCurrencies()
        .then(res => {
          this.currency.dropdownList = this.fixDropdownData(
            res.data.data,
            "currency"
          );
        })
        .catch(e => {
          console.log(e);
        });
    },
    getMeasurementUnits() {
      api
        .getMeasurementUnits()
        .then(res => {
          this.measurementUnit.dropdownList = this.fixDropdownData(
            res.data.data,
            "measurementUnit"
          );
        })
        .catch(e => {
          console.log(e);
        });
    },
    getCategoriesAdmin() {
      api
        .getCategoriesAdmin()
        .then(res => {
          this.category.dropdownList = this.fixDropdownData(
            res.data.data,
            "categories"
          );
        })
        .catch(e => {
          console.log(e);
        });
    },
    getCategories() {
      api
        .getParentCategories()
        .then(res => {
          this.category.dropdownList = this.fixDropdownData(
            res.data.data,
            "categories"
          );
        })
        .catch(e => {
          console.log(e);
        });
    },
    getChildCategories(param) {
      this.subCategoryControll = false;
      this.subcategory.value = null;
      this.subcategory.dropdownList = [];
      api
        .getChildCategories(param)
        .then(res => {
          this.subcategory.dropdownList = new Array(
            ...this.fixDropdownData(res.data.data, "subcategories")
          );
          this.subCategoryControll = true;
          // subcategory
        })
        .catch(e => {
          console.log(e);
        });
    },
    getRegions() {
      let params = {
        type: "create"
      };
      api
        .getRegions(params)
        .then(res => {
          return (this.region.dropdownList = this.fixDropdownData(
            res.data.data,
            "regions"
          ));
        })
        .then(r => {
          this.fixRegions();
        })
        .catch(e => {
          console.log(e);
        });
    },
    fixRegions() {
      let region = JSON.parse(JSON.stringify(this.region));
      if (region.value && region.value.length > 0) {
        for (var i = 0; i < region.value.length; i++) {
          for (var j = 0; j < region.dropdownList.length; j++) {
            if (region.value[i].value === region.dropdownList[j].value) {
              region.value[i] = region.dropdownList[j];
            }
          }
        }
        this.region = region;
      }
    },
    selectCategories(param) {
      this.category.value = param;
      console.log(param.value);
      this.getChildCategories(param.value);
    },
    selectChildCategories(param) {
      this.subcategory.value = param;
    },
    fixDropdownData(data, type) {
      let labelIndex;
      let valueIndex;
      switch (type) {
        case "currency":
          labelIndex = "cur_name";
          valueIndex = "cur_id";
          break;

        case "measurementUnit":
          labelIndex = "mun_unit";
          valueIndex = "mun_id";
          break;

        case "categories":
          labelIndex = "cat_name";
          valueIndex = "cat_id";
          break;

        case "subcategories":
          labelIndex = "cat_name";
          valueIndex = "cat_id";
          break;

        case "regions":
          labelIndex = "reg_name";
          valueIndex = "reg_id";
          break;

        default:
          break;
      }

      let res = [];
      for (var i = 0; i < data.length; i++) {
        const obj = {
          label: data[i][labelIndex],
          value: data[i][valueIndex]
        };
        res.push(obj);
      }
      return res;
    },
    parseNumber(num) {
      return parseFloat(((num * 100) / 100).toFixed());
    },
    fixNumber(min, max, value) {
      console.log(
        this.parseNumber(this[value]),
        this.parseNumber(max),
        this.parseNumber(min)
      );
      if (this.parseNumber(this[value]) > this.parseNumber(max)) {
        this[value] = this.parseNumber(max);
      } else if (this.parseNumber(this[value]) < this.parseNumber(min)) {
        this[value] = this.parseNumber(min);
      }
    },
    rangefunction(e) {
      if (
        !(
          (e.keyCode > 95 && e.keyCode < 106) ||
          (e.keyCode > 47 && e.keyCode < 58) ||
          e.keyCode === 8
        )
      ) {
        e.preventDefault();
      }
    },
    handleFilters(id) {
      this.filters = {};
      this.selectedFilters = {};
      this.emitChange("filters", false);
      let params = {
        id: id
      };
      api.getFilters(params).then(res => {
        let arr = res.data.res;
        for (var i = 0; i < arr.length; i++) {
          this.createFilter(arr[i]);
        }
      });
    },
    createFilter(data) {
      if (data.options && data.options.length > 0) {
        let arr = [];
        for (var i = 0; i < data.options.length; i++) {
          let obj = {
            label: data.options[i].cvl_value,
            value: data.options[i].cvl_id,
            cha_id: data.cha_id,
            cha_datatype: data.cha_datatype
          };
          arr.push(obj);
        }
        let copy = Object.assign({}, this.filters);
        copy[data.cha_type] = arr;
        this.filters = copy;
      }
    },
    changeFilter(name, option) {
      let copy = Object.assign({}, this.selectedFilters);
      copy[name] = option;
      this.selectedFilters = copy;
      this.emitChange("filters", this.selectedFilters);
    }
  },
  watch: {
    "category.value": {
      handler: function() {
        this.emitChange("cat_id", this.category.value.value);
        this.handleFilters(this.category.value.value);
      }
    },
    "subcategory.value": {
      handler: function() {
        if (this.subcategory.value === null) return;
        this.emitChange("cat_id", this.subcategory.value.value);
        this.handleFilters(this.subcategory.value.value);
      }
    },
    "region.value": {
      handler: function() {
        let resArr = [];
        for (var i = 0; i < this.region.value.length; i++) {
          resArr.push(this.region.value[i].value);
        }
        this.emitChange("reg_id", resArr);
      }
    },
    "measurementUnit.value": {
      handler: function() {
        this.emitChange("mun_id", this.measurementUnit.value.value);
      }
    },
    "currency.value": {
      handler: function() {
        this.emitChange("cur_id", this.currency.value.value);
      }
    },
    prices: {
      handler: function() {
        this.emitChange("prices", this.prices);
      }
    },
    declarations: {
      handler: function() {
        this.emitChange("pro_declaration", this.declarations);
      }
    },
    date: {
      handler: function() {
        // 2020-12-22T12:00
        let date = this.date.substring(0, 16);
        this.emitChange("pro_expiry", date);
      }
    },
    quantity: {
      handler: function() {
        this.emitChange("pro_quantity", this.quantity);
      }
    },
    "$route.params.lang": {
      handler: function() {
        this.getCategories();
        this.getRegions();
        this.getMeasurementUnits();
        this.getCurrencies();
        this.getSocialTypes();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  height: 40px;
  border: 1px solid #e8e8e8;
  padding-left: 5px;
}
input:focus {
  outline: none;
}
.custom-manual-wrapper {
  text-align: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  // border: 1px solid rgba(243, 243, 243, 0.5);
  box-sizing: border-box;
  // box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.08);

  @import "@/assets/scss/btnStyles.scss";

  .header {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;

    // border-bottom: 1px solid $main-color;
    color: $blue-1000;
    padding: 15px 0;
  }

  .info.back {
    margin-top: -25px;
    .info-key {
      font-size: 12px !important;
    }
  }
  .line {
    margin: 0 0 30px 0;
    border-bottom: 1px solid $gray-blue-700;
  }
  .info {
    margin-bottom: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;

    .info-key {
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      color: $blue-400;

      // white-space: nowrap;
      // min-width: 150px;
      max-width: 100%;
      width: 582px;
    }
    .warn-info {
      color: $red-400;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      flex-grow: 1;
      justify-content: flex-start;

      // textarea {
      //   width: 100%;
      //   border: 1px solid #dfdfdf;
      //   outline: none;
      //   resize: none;
      //   margin-top: 5px;
      // }
      // input[type="text"] {
      //   width: 100%;
      // }
      .filter-wrapper {
        margin-right: 10px;
        min-width: 150px;
        width: fit-content;
        max-width: calc(100% - 10px);
      }
      .declaration-wrapper {
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          margin-left: 5px;
        }
      }
    }
    .info-key-prices {
      display: flex;
    }
    .price {
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      color: $blue-400;
      height: 32px;
      padding: 0 8px;
      margin-right: 5px;
      width: fit-content !important;
      flex-grow: 0;

      background-color: $gray-blue-100;
      border: 1px solid $gray-blue-700;
      border-radius: 6px;
    }
    .info-value.wide {
      width: 100%;
    }
    .info-value.prices {
      display: flex;
      flex-direction: row;
      align-items: center;
      * {
        margin-right: 10px;
      }
      span {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        color: $blue-400;
      }
      input {
        // width: 60px;
        width: 110px;

        padding: 4px 4px 4px 5px;
        box-sizing: border-box;
        height: 55px;
        // padding: 0 12px;
        border: 1px solid $gray-blue-700;
        border-radius: 8px;
        background-color: $gray-blue-100;
        font-size: 14px;
        outline: none;

        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0%;
        color: $blue-1000;
      }
      .input-price {
        width: 113px;
      }
      .btn {
        border-radius: 10px;
        padding: 20px;
        img {
          margin: 0;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .custom-manual-wrapper {
    .info {
      .info-value {
        width: 100%;
        .dropdown-wrapper {
          min-width: 100% !important;
          max-width: 100% !important;
          width: 100% !important;
        }
      }

      .info-value.prices {
        display: flex;
        flex-direction: row;
        align-items: center;
        * {
          margin-right: 5px;
        }
        span {
          font-size: 14px;
          line-height: 22px;
        }
        input {
          width: 50px;

          padding: 4px 4px 4px 5px;
          box-sizing: border-box;
          height: 45px;

          font-size: 16px;
        }
        .input-price {
          width: 73px;
        }
        .btn {
          border-radius: 10px;
          padding: 0px 13px !important;
          height: 45px;
          margin-right: 0;
          img {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" media="screen">
.vdatetime-input {
  height: 40px;
  border: 1px solid #e8e8e8;
  padding-left: 5px;
}
.vdatetime-popup__header {
  background-color: $blue-600;
}
.vdatetime-popup__actions div {
  color: $blue-600;
}
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  color: #fff;
  background: $blue-600;
}
.vdatetime-time-picker__item--selected {
  color: $blue-600;
}
</style>
